/**
 * <s-product-gallery> — primary media viewer with a thumbnail strip.
 *
 * Required markup:
 *   [data-gallery-slide="N"] — one per media item; all but the active one carry `hidden`.
 *   button[data-gallery-thumb="N"] — thumbnail that shows slide N; the active one has aria-current="true".
 */
class SProductGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', this.#handleClick, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb || !this.contains(thumb)) return;
    this.show(thumb.getAttribute('data-gallery-thumb'));
  };

  show(index) {
    for (const slide of this.querySelectorAll('[data-gallery-slide]')) {
      const isActive = slide.getAttribute('data-gallery-slide') === String(index);
      if (!isActive && !slide.hidden) {
        for (const video of slide.querySelectorAll('video')) video.pause();
      }
      slide.hidden = !isActive;
    }
    for (const thumb of this.querySelectorAll('[data-gallery-thumb]')) {
      if (thumb.getAttribute('data-gallery-thumb') === String(index)) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    }
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
